import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { accountTypes, indicatorTypes, invoiceStatusTypes, newRow, receiptTypes } from './utils';
import { AGridColDef } from '../../../common/data-grid/ADataGridColDef';
import AAutoComplete from '../../../common/form-fields-mui/AAutoComplete';
import AInput from '../../../common/formFeilds/customInput/AInput';
import { regex } from '../../../common/constant';
import CustomDatePickerV2 from '../../../common/commonComponents/CustomDatePicker-V2';
import AToggleButton from '../../../../../../components/AToggleButton';
import moment from 'moment';
import { ActionsCellComponent } from '../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import ADataGrid from '../../../common/data-grid/ADataGrid';
import { gridComponents, gridStyles } from '../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import NoRowOverlay from '../../../masters/holidayMaster/NoRowOverlay';
import { editCellContainerStyle } from '../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { saveOrDeleteMsg } from '../../../edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseSquareBlack.svg";
import { GridRowModes } from '@mui/x-data-grid';
import { generateRandomId, isObjEmpty } from '../../../common/utils/methods/commonMethods/utilityMethod';
import { failureToast } from '../../../common/utils/methods/toasterFunctions/function';
import { Tooltip } from "@mui/material";

const ListComponent = ({
    rows,
    loading,
    createUpdateHandler
}, ref) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});

    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({
            ...prev,
            [key]: value,
        }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);

    const handleSaveClick = async (params) => {
        // if (!rowForm?.account || rowForm.account.length < 9 || rowForm.account.length > 18) {
        //     failureToast("Account must be between 9 to 18 digits");
        //     return;
        // }
        createUpdateHandler(rowForm);
    };

    const startEditing = (id, form) => {
        const updatedForm = {
            ...form,
            effectiveDate: form?.effectiveDate || moment().format("YYYY-MM-DD"),
        };
        setRowModesModel((oldModel) => ({
            [id]: {
                mode: GridRowModes.Edit,
                // fieldToFocus: "financeInstitution"
            },
        }));
        setRowForm(updatedForm);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let randomId = generateRandomId();
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: randomId,
                effectiveDate: moment().format("YYYY-MM-DD"),
            };
            startEditing(randomId, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const columns = [
        new AGridColDef("receiptType", "Receipt Type", false)
            .setMinWidth(110)
            .setFlex(0.5)
            .editable(true)
            .setValueGetter((params) => params?.value?.label)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.receiptType}
                        handleChange={(value) => {
                            rowFormHandler(value, "receiptType");
                        }}
                        items={receiptTypes}
                        isMulti={false}
                        placeholder={"Select"}
                    // autoFocus={params?.hasFocus}
                    // isDisabled={!rowForm?.isNew}
                    />
                </div>
            )),
        new AGridColDef("accountType", "SFGL Account Type", false)
            .setMinWidth(120)
            .setFlex(0.5)
            .editable(true)
            .setValueGetter((params) => params?.value?.label)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.accountType}
                        handleChange={(val) => {
                            rowFormHandler(val, "accountType");
                            rowFormHandler(val?.value, "description")
                        }}
                        items={accountTypes}
                        isMulti={false}
                        placeholder={"Select"}
                    />
                </div>
            )),
        new AGridColDef("indicatorType", "Indicator Type", false)
            .setMinWidth(110)
            .setFlex(0.5)
            .editable(true)
            .setValueGetter((params) => params?.value?.label)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.indicatorType}
                        handleChange={(val) => {
                            rowFormHandler(val, "indicatorType");
                        }}
                        items={indicatorTypes}
                        isMulti={false}
                        placeholder={"Select"}
                    />
                </div>
            )),
        new AGridColDef("account", "Account", false)
            .setMinWidth(150)
            .setFlex(1)
            .editable(true)
            .setValueGetter((params) => params?.value)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AInput
                        value={rowForm?.account}
                        handler={(val) => {
                            rowFormHandler(val, 'account')
                        }}
                        placeholder={"Enter"}
                        maxLength={18}
                        regex={regex.numeric}
                    />
                </div>
            )),

        new AGridColDef("description", "Description", false)
            .setMinWidth(180)
            .setFlex(0.8)
            .editable(true)
            .renderCellComponent((params) => params?.value)
            .renderEditCellComponent((params) => rowForm?.description),

        new AGridColDef("invoiceStatus", "Invoice Status", false)
            .setMinWidth(130)
            .setFlex(1)
            .editable(true)
            .setValueGetter((params) => params?.value?.label)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.invoiceStatus}
                        handleChange={(val) => {
                            rowFormHandler(val, "invoiceStatus");
                        }}
                        items={invoiceStatusTypes}
                        isMulti={false}
                        placeholder={"Select"}
                    />
                </div>
            )),

        new AGridColDef("effectiveDate", "Effective Date", false)
            .setMinWidth(150)
            .setFlex(1)
            .editable(true)
            .setValueGetter((params) => params?.value)
            .renderCellComponent((params) =>
                params?.value ? (
                    <Tooltip title={moment(params?.value).format("DD-MM-YYYY")}>
                        <div className={`ellipsis-text-container`}>
                            {moment(params?.value).format("DD-MM-YYYY")}
                        </div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                )
            )
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <CustomDatePickerV2
                        value={rowForm?.effectiveDate}
                        handler={(index, date) => {
                            rowFormHandler(moment(date).format("YYYY-MM-DD"), "effectiveDate");
                        }}
                        placeHolder={"Select"}
                    />
                </div>
            )),



        new AGridColDef("status", "Status", false)
            .setMinWidth(90)
            .setFlex(0.5)
            .editable(true)
            .renderCellComponent(params =>
                <AToggleButton
                    value={params?.value}
                    showText={false}
                />
            )
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AToggleButton
                        value={rowForm?.status}
                        handleChange={val => rowFormHandler(val, "status")}
                        showText={false}
                    />
                </div>
            )),



        new AGridColDef("updatedOn", "Last Updated On/By", false)
            .setMinWidth(130)
            .setFlex(1)
            .editable(false)
            .setValueGetter((params) =>
                `${moment(params.value).format("DD-MMM-YY")} by ${params.row.updatedBy}`
            ),

        new AGridColDef("createdOn", "Created On/By", false)
            .setMinWidth(130)
            .setFlex(1)
            .editable(false)
            .setValueGetter((params) =>
                `${moment(params.value).format("DD-MMM-YY")} by ${params.row.createdBy}`
            ),

        new AGridColDef("actions", "Action", false)
            .setMinWidth(110)
            .setFlex(0.8)
            .editable(true)
            // .pinColumnLast(true)
            .columnAlign("right")
            .renderCellComponent(
                (params) =>
                    <ActionsCellComponent
                        mode={"view"}
                        handleEditClick={handleEditClick}
                        params={params}
                    />
            )
            .renderEditCellComponent((params) => (
                <ActionsCellComponent
                    mode={"edit"}
                    // isSaveDisabled={!rowForm?.userName}
                    handleSaveClick={handleSaveClick}
                    params={params}
                    cancelIcon={
                        <CloseIcon
                            className="mx-2 cursor"
                            onClick={() => handleCancelClick(params)}
                        />
                    }
                />
            )),
    ];



    return (
        <ADataGrid
            removeWrapperContainer
            rowModesModel={rowModesModel}
            rows={rowData || []}
            columns={columns}
            rowId={(row) => row.id}
            rowHeight={50}
            loading={false}
            // rowCount={totalRecords}
            // nextButtonHandler={pageChangeHandler}
            // currentPage={currentPage}
            components={{
                ...gridComponents,
                NoRowsOverlay: () => (
                    <NoRowOverlay message={loading ? "Loading..." : null} />
                ),
            }}
            sx={gridStyles}
            autoHeight
            hidePagination
        // pinLastColumn
        />
    );
}

export default forwardRef(ListComponent);
